import { Box, Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useContext } from 'react'
import globalStyles from "../../../assets/styles/global.module.scss";
import styles from "../../../assets/styles/componentStyles/template.module.scss";
import scheduleMeetingStyle from "../../../assets/styles/componentStyles/scheduleMeetingStyles/scheduleMeetingStyle.module.scss";
import featureSectionStyles from "../../../assets/styles/componentStyles/scheduleMeetingStyles/featureSectionStyle.module.scss";
import reachOutStyles from "../../../assets/styles/componentStyles/scheduleMeetingStyles/reachOutStyle.module.scss"; 
import channelsStyles from "../../../assets/styles/componentStyles/scheduleMeetingStyles/channelsStyles.module.scss";
import { UserContext, UserContextPayload } from '../../../context/userContext';
import GlobalPageHeaderText from '../globalPageHeaderText';
import IconsColor from '../iconsColor';
import ChannelItem from './channelsItem';
import lightIcon from "../../../assets/images/scheduleMeeting/lightning.svg"
import rightTick from '../../../assets/images/scheduleMeeting/rightTick.png';
import liveChat from '../../../assets/images/scheduleMeeting/liveChat.png';
import demo from '../../../assets/images/scheduleMeeting/demo.png';
import whatsappIcon from '../../../assets/images/scheduleMeeting/whatsapp.png';
import facebookIcon from '../../../assets/images/scheduleMeeting/facebook.png';
import instagramIcon from '../../../assets/images/scheduleMeeting/instagram.png';
import websiteIcon from '../../../assets/images/scheduleMeeting/website.png';
import Card from './card';
import ContactItem from './contactItem';
import { isVendor } from '../../../utils/constants';

const ScheduleMeetingAIChatbot = () => {

    const { setFlagShowScheduleCall, vendorData, userDetail } = useContext(UserContext) as UserContextPayload;
    const innerHeight = window.innerHeight - 90;

    const breakPoints = {
        flagLaptopScreen: useMediaQuery('(max-width : 1000px) and (min-width : 0px)'),
        flagMobileScreen: useMediaQuery('(max-width : 600px) and (min-width : 0px)'),
    } 

    const contentArr = [
        ...(!isVendor(vendorData, userDetail) ? [
            { 
                title: "Talk to Us — We're Just a Click Away!", 
                desc: 'Need assistance or want to know more?', 
                btnText: 'Start a Live Chat',
                btnIcon: liveChat,
                handleBtnClick: () => {
                    window.open(" https://api.whatsapp.com/send?phone=917861834273", "_blank");
                }, 
            },
        ]: []),
        { 
            title: "Schedule a Meeting", 
            desc: "Let's talk about how our AI Chatbot can work for you.", 
            btnText: 'Schedule a Demo', 
            btnIcon: demo, 
            handleBtnClick: () => {
                setFlagShowScheduleCall(true);
            },
        },
    ] 

    const channels = [
        { icon: whatsappIcon, label: 'WhatsApp', className: 'whatsapp', description: "Effectively communicate with customers using WhatsApp." },
        { icon: facebookIcon, label: 'Facebook', className: 'facebook', description: "Grow your community and drive interactions with Facebook Messenger."},
        { icon: instagramIcon, label: 'Instagram', className: 'instagram', description: "Connect your brand with your audience on Instagram." },
        { icon: websiteIcon, label: 'Website', className: 'website', description: "Engage visitors in real time & enhance their experience on your website." },
    ]; 

    const usages = [
        { title: 'AI Intelligence', desc: 'Natural conversations' },
        { title: 'Smart Analytics', desc: 'Track conversations' },
        { title: 'Human Handover', desc: 'Seamless escalation' },
        { title: 'Instant Replies', desc: 'Reduce response time' },
        { title: 'Multilingual', desc: 'Global support' },
        { title: '24/7 Available', desc: 'Never miss customers' },
    ];


    return (
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${styles.templateWrapper}`}>
            <Grid container className={`${styles.chatbotGrid} ${styles.mainScreenPadding}`} sx={{paddingBottom: "0px !important"}}> 
                <Grid item sx={{ width: "100%" }}>
                    <Grid container sx={{ alignItems: "center" }}>
                        <Grid item xs={12} sx={{ marginBottom: "10px" }}>
                            <GlobalPageHeaderText
                                mainHeadText={"AI Chatbot"}
                                flagMainTextOnly
                            />
                        </Grid>  
                        {!breakPoints.flagMobileScreen && 
                            <Divider className={`${globalStyles.dividerStyles} ${styles.dividerStyle}`} sx={{ paddingTop: "6px !important" }} />
                        }
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12} sx={{overflow: "auto", maxHeight: `${innerHeight}px !important`}}> 
                <Grid container gap={2} className={`${styles.chatbotGrid} ${styles.mainScreenPadding}`} alignItems={"center"}>
                    <Box className={`${scheduleMeetingStyle.outerContainer} ${featureSectionStyles.outerContainer}`}>
                        <Box className={featureSectionStyles.innerContainer}>
                            <Box className={featureSectionStyles.badgeContainer}>
                                <IconsColor iconName='rocketIcon' height={20} width={20} />
                                <Typography className={featureSectionStyles.badgeText}>
                                    Next-Generation AI Technology
                                </Typography>
                            </Box>
                            <Typography className={featureSectionStyles.titleText}>
                                Boost Customer Engagement with Next-Gen AI Chatbot
                            </Typography>
                            <Typography className={featureSectionStyles.descText}>
                                Discover how our AI-driven chatbot transforms conversations into conversions, enhancing user experience while optimizing your business operations.
                            </Typography>
                        </Box>
                    </Box>

                    <Grid container className={channelsStyles.outerContainer}>
                        <Grid item xs={breakPoints.flagLaptopScreen ? 12 : 6} className={channelsStyles.cardItem}>
                            <Card>
                                <Typography className={channelsStyles.titleText}>
                                    Deploy Across Multiple Channels
                                </Typography>
                                <Box className={channelsStyles.itemContainer} flexWrap={"wrap"}>
                                    {channels.map((channel, i) => (
                                        <ChannelItem key={i} {...channel} />
                                    ))}
                                </Box>
                            </Card>
                        </Grid>

                        <Grid item xs={breakPoints.flagLaptopScreen ? 12 : 6} className={channelsStyles.cardItem}>
                            <Card>
                                <Box className={channelsStyles.titleContainer}>
                                    <img src={lightIcon} alt="LightIcon" />
                                    <Typography className={channelsStyles.titleText}>
                                        Why Choose Our AI Chatbot?
                                    </Typography>
                                </Box>
                                <Box className={channelsStyles.itemContainer}>
                                    {usages.map((usage, i) => {
                                        return (
                                            <Box key={i} className={channelsStyles.item}>
                                                <img src={rightTick} alt="rightTick" />
                                                <Box className={channelsStyles.itemContent}>
                                                    <Typography className={channelsStyles.usageTitle}>
                                                        {usage.title}
                                                    </Typography>
                                                    <Typography className={channelsStyles.usageDesc}>
                                                        {usage.desc}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </Card>
                        </Grid>
                    </Grid>

                    <Grid container className={reachOutStyles.container}>
                        <Grid item xs={12}>
                            <Typography className={reachOutStyles.reachoutText}>
                                👉 <strong>Reach out to our team</strong> to enable this feature and explore how it can elevate your business.
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container gap={"30px"} alignItems={"center"} justifyContent={"center"}>
                                {contentArr.map((content, i) => {
                                    return (
                                        <Grid item xs={breakPoints.flagLaptopScreen ? 12 : 6} className={reachOutStyles.cardItem}>
                                            <Card>
                                                <ContactItem key={i} {...content} />
                                            </Card>
                                        </Grid>
                                    )
                                })}
                            </Grid>
                        </Grid>
                    </Grid>
                    
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ScheduleMeetingAIChatbot
